module.exports = __webpack_public_path__ + "static/media/adv-img2.e8ed6975.jpg";